import * as THREE from 'three'
import { CHUNK_SIZE } from '../shared/shared'
import { Flags } from '../shared/Flags'

const TILE_SIZE = 1

export class FlagOverlay {
  constructor(scene) {
    this.scene = scene
    this.visible = false
    this.meshes = {}

    const geo = new THREE.PlaneGeometry(TILE_SIZE, TILE_SIZE)
    geo.translate(0, TILE_SIZE / 2, 0)

    for (const flag of Object.values(Flags)) {
      const mat = new THREE.MeshBasicMaterial({
        color: flag.color,
        transparent: true,
        opacity: 0.35,
        depthWrite: false,
      })
      const mesh = new THREE.InstancedMesh(geo, mat, 16384)
      mesh.frustumCulled = false
      mesh.count = 0
      mesh.visible = false
      mesh.renderOrder = 999
      scene.add(mesh)
      this.meshes[flag.id] = { mesh, instances: new Map() }
    }

    this._chunks = new Map()
    this._dummy = new THREE.Object3D()
  }

  setVisible(visible) {
    if (this.visible === visible) return
    this.visible = visible
    for (const { mesh } of Object.values(this.meshes)) {
      mesh.visible = visible
    }
  }

  update(chunk) {
    this._chunks.set(chunk.id, chunk)
    this._rebuild()
  }

  remove(chunkId) {
    this._chunks.delete(chunkId)
    this._rebuild()
  }

  _rebuild() {
    for (const entry of Object.values(this.meshes)) {
      entry.instances.clear()
    }

    for (const chunk of this._chunks.values()) {
      if (!chunk.flags) continue
      const baseX = chunk.x * CHUNK_SIZE
      const baseY = chunk.y * CHUNK_SIZE
      for (let ly = 0; ly < CHUNK_SIZE; ly++) {
        for (let lx = 0; lx < CHUNK_SIZE; lx++) {
          const f = chunk.flags[ly * CHUNK_SIZE + lx]
          if (!f) continue
          const wx = baseX + lx
          const wy = baseY + ly
          for (const [bit, entry] of Object.entries(this.meshes)) {
            if (f & Number(bit)) {
              entry.instances.set(`${wx},${wy}`, { wx, wy })
            }
          }
        }
      }
    }

    for (const { mesh, instances } of Object.values(this.meshes)) {
      let i = 0
      for (const { wx, wy } of instances.values()) {
        this._dummy.position.set(wx, wy, 5)
        this._dummy.updateMatrix()
        mesh.setMatrixAt(i++, this._dummy.matrix)
      }
      mesh.count = i
      mesh.instanceMatrix.needsUpdate = true
    }
  }
}
